import usePreProdDetail from '../../application/bloc/usePreProdDetail';
import useRateCalcBottomSheet from '../../application/hooks/useRateCalcBottomSheet';

import {
  Skeleton,
  DetailItemB,
  Button,
  Description,
  BridgeModal,
  SimpleItem,
  Spacer,
} from 'oui';
import { ListWithGap, SideBox } from '../etc/LBox/LBox';

import { addUnitToMaxAmount } from '../../application/helper/filter';
import RateCalcBottomSheet from '../feedback/RateCalcBottomSheet/RateCalcBottomSheet';

const PreProdDetail = () => {
  const {
    isLoading,
    productInfo,
    custProductDetailItem,
    hashTagList,
    productOptions,
    executeLoan,
    sendBeaconExecuteButton,
    sendBeaconClkBtnIntrstCalc,
    bridgeModal,
    isDisabledMainBtn,
    calc_item,
  } = usePreProdDetail();

  const { isBottomSheetOpen, onClickOpenBottomSheet, onClickCloseBottomSheet } =
    useRateCalcBottomSheet();

  const handleExecuteButton = (e: any) => {
    sendBeaconExecuteButton(e.target.innerText || '');
    executeLoan();
  };

  const handleClickOpenBottomSheet = () => {
    sendBeaconClkBtnIntrstCalc('이자 계산기');
    onClickOpenBottomSheet();
  };

  const handleClickCloseBottomSheet = () => {
    onClickCloseBottomSheet();
  };

  return (
    <>
      {isLoading ? (
        <Skeleton type={'d'} />
      ) : (
        <>
          <DetailItemB
            avatar={{
              source: productInfo?.logoImgUrl,
              alt: productInfo?.compNm,
            }}
            textTitle={productInfo?.compNm}
            subTitle={productInfo?.productNm}
            labelA={'금리'}
            labelB={'한도'}
            valueA={`${custProductDetailItem?.interestRate}%`}
            valueB={addUnitToMaxAmount(custProductDetailItem?.amount)}
            eventChip={hashTagList}
          />
          <ListWithGap gap={0}>
            <Button
              configuration={'contained'}
              flexible={true}
              children={'신청하기'}
              onClick={handleExecuteButton}
              isDisabled={isDisabledMainBtn}
              state={isDisabledMainBtn ? 'disabled' : 'enabled'}
            />
          </ListWithGap>
          {/* <Divider type="" /> */}
          <SideBox>
            <Spacer size={'xs'} />
            <SimpleItem
              avatar={{
                source: calc_item.logoImgUrl,
                alt: calc_item.primaryText,
              }}
              headerText={calc_item.primaryText}
              subheaderText={calc_item.secondaryText}
              onClickSimpleItem={handleClickOpenBottomSheet}
              state={'enabled'}
            />
            <Spacer size={'md'} />
          </SideBox>

          {productOptions?.length && (
            <Description
              infoText={productInfo?.infoText}
              productOptions={productOptions}
            />
          )}
        </>
      )}

      <BridgeModal
        isBridgeModalOpen={bridgeModal.open}
        message={bridgeModal.message}
        onDone={bridgeModal.handleDone}
        timeout={bridgeModal.timeout}
      />

      <RateCalcBottomSheet
        isShow={isBottomSheetOpen}
        handleClickOpenBottomSheet={handleClickOpenBottomSheet}
        handleClickCloseBottomSheet={handleClickCloseBottomSheet}
        preset={{
          amount: (custProductDetailItem?.amount / 10000).toString(),
          interestRate: custProductDetailItem?.interestRate.toString(),
          term: '60',
          maxTerm: 120,
        }}
      />
      {/* <RateCalculator
        preset={{
          amount: `${custProductDetailItem?.amount}`,
          interestRate: `${custProductDetailItem?.interestRate}`,
          term: '60',
        }}
        showInput={{
          interestRateInput: false,
        }}
      /> */}
    </>
  );
};

export default PreProdDetail;
